import { useContext } from 'react';

import { TreeMapCustomTooltipContext } from '../contexts/TreeMapCustomTooltipContext.js';

export const useTreeMapCustomTooltip = () =>
  useContext(TreeMapCustomTooltipContext);
